// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Uu68X","description":"styles_description__VUyFg","footer":"styles_footer__q4eNr"};